import { createContext, useContext, useEffect } from 'react';
import { usePartnerSearchContext } from '../../Partner/Search';
import useSearchResultsTabNavigation from '../../../../../hooks/ui/useSearchResultTabNavigation';

const NavigationBetweenPartnerListsContext = createContext();

export function useNavigationBetweenPartnerListsContext() {
  const context = useContext(NavigationBetweenPartnerListsContext);
  if (!context) {
    console.error('useNavigationBetweenPartnerListsContext: the component from which you are trying to use this context must be a ContextProviderNavigation component descendant.');
  }
  return context;
}

export default function ContextProviderNavigationBetweenPartnerLists({children}) {

  const {
    activateFoundPartners,
    isFoundPartnersActive,
    activateSavedPartners,
    isSavedPartnersActive,
    activateMyPartners,
    isMyPartnersActive
  } = useSearchResultsTabNavigation();

  const { foundPartners } = usePartnerSearchContext();

  useEffect(()=>{ activateFoundPartners() },[foundPartners]);

  return (
    <NavigationBetweenPartnerListsContext.Provider value={
      {
        activateFoundPartners,
        isFoundPartnersActive,
        activateSavedPartners,
        isSavedPartnersActive,
        activateMyPartners,
        isMyPartnersActive
      }
    }>{children}</NavigationBetweenPartnerListsContext.Provider>
  );
}
